/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { connect } from 'react-redux';
import { TSS_DARK_BLUE } from 'tss-core-lib-common';
import { HEADER_HEIGHT, IMG_TSS_LOGO } from 'tss-core-lib-components';

let styles;

const Header = () => (
  <div className={ css( styles.container ) }>
    <div className={ css( styles.logoContainer ) }>
      <img src={ IMG_TSS_LOGO } alt="TSS Logo" />
    </div>
    <div className={ css( styles.headerInfoContainer ) } />
  </div>
);

Header.defaultProps = {};

styles = StyleSheet.create( {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: HEADER_HEIGHT,
    backgroundColor: TSS_DARK_BLUE,
    display: 'flex',
    alignItems: 'stretch',
    zIndex: 50,
  },

  logoContainer: {
    position: 'relative',
    top: '-0.45rem',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 2.3rem',
  },

  userContainer: {
    outline: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '0 2.3rem 0 0',
    cursor: 'pointer',
    position: 'relative',

    ':hover .arrow-down': {
      opacity: 1,
    },
  },

  headerInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 3rem 0 0',
  },

  userMenuContainer: {
    position: 'absolute',
    outline: 0,
    top: '100%',
    left: 0,
    right: 0,
    margin: '2px 0 0 0',
    padding: 0,
    listStyleType: 'none',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.3)',
  },

  logoutLink: {
    display: 'block',
    textDecoration: 'none',
    padding: '1.6rem',
    margin: 0,
    fontSize: '1.6rem',
    color: TSS_DARK_BLUE(),
  },

  userMenuItem: {
    cursor: 'pointer',
    padding: '1.6rem',
    margin: 0,
    fontSize: '1.6rem',
    color: TSS_DARK_BLUE(),
  },

  userAvatar: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    border: 0,
    borderRadius: '50%',
    width: '4.8rem',
    height: '4.8rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 1rem 0 1.1rem',
  },

  arrowDown: {
    color: 'white',
    opacity: 0.5,
    transition: 'opacity 0.2s linear',
  },

  userDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    color: 'white',
  },

  username: {
    fontSize: '1.2rem',
    fontWeight: 600,
    margin: '0.3rem 0',
  },

  userWork: {
    fontSize: '1.2rem',
    margin: '0.3rem 0',
    opacity: 0.6,
  },
} );
export default connect()( Header );



// WEBPACK FOOTER //
// ./src/pages/Header.js